"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_router_dom_1 = require("react-router-dom");
const react_error_boundary_1 = require("react-error-boundary");
//
// components
//
const Customers = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Customers'))));
const Orders = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Orders'))));
const Settings = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Settings'))));
const Account = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Account'))));
const Metabase = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Metabase'))));
const Shipping = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Shipping'))));
const TrackingPages = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./TrackingPages'))));
const TrackingPageManager = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./TrackingPageManager'))));
const Apps = (0, react_1.lazy)(() => Promise.resolve().then(() => __importStar(require('./Apps'))));
const Layout_1 = require("./Layout");
const ErrorFallback_1 = __importDefault(require("components/general/ErrorFallback"));
const LoadingSpinner_1 = __importDefault(require("components/general/LoadingSpinner"));
//
// styles
//
const StyledMessageContainer_1 = require("./StyledMessageContainer");
const Loading = () => (react_1.default.createElement(StyledMessageContainer_1.StyledMessageContainer, null,
    react_1.default.createElement(LoadingSpinner_1.default, null)));
// eslint-disable-next-line react/no-multi-comp
const Wrapper = ({ children }) => {
    const location = (0, react_router_dom_1.useLocation)();
    return (react_1.default.createElement(react_error_boundary_1.ErrorBoundary, { FallbackComponent: ErrorFallback_1.default, resetKeys: [location] },
        react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(Loading, null) }, children)));
};
// eslint-disable-next-line react/no-multi-comp
const Dashboard = ({ onLogout }) => (react_1.default.createElement(react_router_dom_1.Routes, null,
    react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Layout_1.Layout, { onLogout: onLogout }), path: '/' },
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Orders, null)), path: 'orders' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Customers, null)), path: 'customers' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Settings, null)), path: 'settings/*' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Account, null)), path: 'account/*' }),
        react_1.default.createElement(react_router_dom_1.Route, { path: 'reports' },
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                    react_1.default.createElement(Metabase, null)), path: ':metabaseId' }),
            react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                    react_1.default.createElement(Shipping, null)), path: 'shipping' })),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(TrackingPages, null)), path: 'tracking_pages' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(TrackingPageManager, null)), path: 'tracking-page/manager/*' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(Wrapper, null,
                react_1.default.createElement(Apps, null)), path: 'apps' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_router_dom_1.Navigate, { to: 'orders' }), path: '*' }),
        react_1.default.createElement(react_router_dom_1.Route, { element: react_1.default.createElement(react_router_dom_1.Navigate, { to: 'orders' }), index: true }))));
exports.default = Dashboard;
